import Organization from './Organization';
import CityType from './typelist/CityType';
import StateType from './typelist/StateType';

export default class User {
    public uid?: string;

    public userName?: string;

    public photoURL?: string;

    public backPhotoURL?: string;

    public email?: string;

    public roles: any[] = [];

    public organizations: Organization[] = [];

    public state?: StateType;

    public city?: CityType;

    public phone?: string;

    public address?: string;

    public homeTown?: string;

    public description?: string;

    public dateOfBirth?: Date;

    static parse(obj: any): User {
      const finalUser = new User();
      finalUser.email = obj.email;
      finalUser.photoURL = obj.photoURL;
      finalUser.backPhotoURL = obj.backPhotoURL;
      finalUser.roles.push(obj.role);
      finalUser.uid = obj.uid;
      finalUser.userName = obj.userName;
      return finalUser;
    }
}
